const initDownloadTargets = () => {
  document.querySelectorAll('.btn-download')
  .forEach(button => button.setAttribute('target', '_blank'))
}

document.addEventListener('DOMContentLoaded', initDownloadTargets)


document.addEventListener('DOMContentLoaded', () =>
  document.body.classList.add('bg-light'))
